// @ts-nocheck
import React from 'react';
import { useCompanyContext } from '../context/CompanyContext';
import { WorkflowHomePage } from '../workflow/CompanyApp';

export default function OverviewPage() {
  const { data, setData } = useCompanyContext();
  return <WorkflowHomePage formData={data} setFormData={setData} />;
}
